module.exports = __webpack_public_path__ + "img/joy-bg.c75361cb.png";